import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import { Trans } from 'react-i18next';
import ProductsTable from '../ProductsTable';
import UpcomingEvents from '../UpcomingEvents';
import i18next from '../../translations/i18n';
import './index.scss';

const ProductLayer = ({ product, show, onHide, onEscapeKeyDown, postTitle }) => (
  <Modal
    show={show}
    onHide={onHide}
    onEscapeKeyDown={onEscapeKeyDown}
    aria-labelledby="contained-modal-title-vcenter"
    centered
    style={{ opacity: show ? 1 : 0 }}
    dialogClassName="modal-w"
    className="modal-container underlying-modal"
  >
    <Modal.Header closeButton className="border-0 mx-5 px-5">
      <Card.Link className="back-link" onClick={() => onHide(!show)}>
        <span className="back-arrow" /> {i18next.t('backTo')} <Trans>{product.name}</Trans>
      </Card.Link>
    </Modal.Header>
    <Modal.Body className="p-4 px-sm-3 mx-sm-3 mb-sm-3 px-md-5 mx-md-5 mb-md-5">
      <ProductsTable underlying={product.name} assetClass={product.assetClass} postTitle={postTitle} />
      <UpcomingEvents underlying={product.name} postTitle={postTitle} />
    </Modal.Body>
  </Modal>
);

ProductLayer.defaultProps = {
  postTitle: '',
};

ProductLayer.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
    assetClass: PropTypes.string.isRequired,
  }).isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onEscapeKeyDown: PropTypes.func.isRequired,
  postTitle: PropTypes.string,
};

export default ProductLayer;
